/**
 * Checks if two arrays contain the same set of elements, regardless of order.
 * @param left First array of strings
 * @param right Second array of strings
 * @returns True if both arrays have the same unique elements
 */
export function areSetsEqual<T>(left: T[], right: T[]): boolean {
  if (left === right) return true
  
  const leftSet = new Set(left)
  const rightSet = new Set(right)
  
  if (leftSet.size !== rightSet.size) return false

  for (const value of leftSet) {
    if (!rightSet.has(value)) return false
  }

  return true
}
